var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegration = function SvgIntegration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9 14c-4.418 0-8-1.343-8-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17 4v6.5M1 4v14c0 1.657 3.582 3 8 3q.252 0 .5-.006"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 4,
    stroke: "#3F4651",
    strokeWidth: 1.5,
    rx: 8,
    ry: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5 7v2M5 14v2M15 15.667V17m0 0v1.333M15 17h1.333M15 17h-1.333M19 17a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  })));
};
export default SvgIntegration;